export enum MimeType {
    PDF = 'application/pdf',
    DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    DOC = 'application/msword',
    XLSX = 'pplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    XLS = 'application/vnd.ms-excel',
    PNG = 'image/png',
    JPG = 'image/jpeg',
    JPEG = 'image/jpeg',
}